import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";


const policies = {
  terms: {
    title: "Terms of Service",
    intro: "These terms apply when you browse AeroCore Scripts or purchase a digital product through our Tebex checkout.",
    sections: [
      ["Purchases and delivery", "Payments, account checks, taxes, and digital delivery are handled through Tebex. You must use accounts you control and provide accurate information during checkout."],
      ["Product requirements", "Review the product page before buying. Framework support, dependencies, installation steps, and included support can differ by product."],
      ["Licence", "A purchase gives you the licence described on the relevant product page and at checkout. Unless that licence expressly permits it, you may not redistribute, resell, leak, or share the files or access credentials."],
      ["Third-party services", "FiveM/Cfx.re, Discord, and Tebex are independent services with their own terms and availability. AeroCore Scripts is not affiliated with or endorsed by Rockstar Games."],
      ["Misuse", "We may restrict support or access where there is evidence of fraud, unauthorised redistribution, abuse, or an attempt to bypass the checkout or licensing process."],
      ["Contact", "Questions about a product or these terms can be sent through the contact page before purchase."],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    intro: "We collect only the information needed to operate the store, connect purchases, provide support, and protect the service.",
    sections: [
      ["Information we process", "This can include your FiveM/Cfx account identifier, Discord user ID, contact-form details, purchase references returned by Tebex, and basic technical logs."],
      ["What we do not receive", "AeroCore Scripts does not receive or store your FiveM password, Discord password, or payment-card details. Account sign-in happens with the relevant provider and payment happens inside Tebex."],
      ["Cookies and local storage", "Short-lived, secure cookies connect the FiveM and Discord checkout steps. The admin area uses browser storage for its own signed session token; this does not apply to customers."],
      ["Service providers", "Tebex processes checkout and payment information, Discord handles Discord authorisation, Cfx.re handles FiveM identity, and our hosting provider runs the website infrastructure."],
      ["Retention and requests", "We keep operational and support data only as long as reasonably needed for purchases, security, support, and legal obligations. Contact us to request access, correction, or deletion where applicable."],
    ],
  },
  refund: {
    title: "Refund Policy",
    intro: "AeroCore products are digital goods. Please check compatibility and requirements before completing a purchase.",
    sections: [
      ["Before requesting a refund", "If a product is not working as described, contact support with the Tebex transaction reference and enough detail to reproduce the problem. We will first try to resolve delivery or installation issues."],
      ["Assessment", "Refund requests are assessed under the terms shown during Tebex checkout and applicable consumer law. A change of mind after successful digital delivery may not qualify, subject to rights that cannot legally be excluded."],
      ["Unauthorised purchases", "Report suspected fraud promptly through the contact page and through the payment or Tebex support channel shown on your receipt."],
      ["How to contact us", "Use the contact form and include the email used at checkout plus the Tebex transaction reference. Never send card details or passwords."],
    ],
  },
};

const LegalPage = ({ policy }) => {
  const content = policies[policy];
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="mx-auto max-w-4xl px-6 pb-24 pt-32 md:px-12">
        <p className="mb-4 text-xs uppercase tracking-[0.25em] text-primary">AeroCore Scripts</p>
        <h1 className="mb-5 text-4xl font-bold uppercase tracking-tight">{content.title}</h1>
        <p className="mb-12 max-w-3xl leading-relaxed text-muted-foreground">{content.intro}</p>
        <div className="space-y-6">
          {content.sections.map(([heading, body]) => (
            <section key={heading} className="rounded-xl border border-slate-800 bg-slate-950/50 p-6">
              <h2 className="mb-3 text-lg font-bold">{heading}</h2>
              <p className="leading-relaxed text-muted-foreground">{body}</p>
            </section>
          ))}
        </div>
        <p className="mt-10 text-sm text-muted-foreground">
          Need help? <Link className="text-primary hover:underline" to="/contact">Contact AeroCore Scripts</Link>.
        </p>
      </main>
      <Footer />
    </div>
  );
};

export default LegalPage;
